const oneDay = 24 * 60 * 60 * 1000;

export const getCurrentYear = () => new Date(Date.now() - oneDay).getFullYear();
